import styles from './BreakLine.module.css';

export const BreakLine = () => {
  return <div className={styles.line}></div>;
};
